<template>
  <div class="agentic-dashboard-wrapper">
    <!-- Show Home view for home, all, starred, shared routes, or Dashboard view if dashboardId is present -->
    <Home 
      v-if="!dashboardId && (isHomeRoute || isAllRoute || isStarredRoute || isSharedRoute)" 
    />
    <DashboardView 
      v-else-if="dashboardName || dashboardId || hasMessage"
      :dashboard-id="dashboardId"
      :dashboard-name="dashboardName"
      :initial-message="initialMessage"
      :dashboard-data="dashboardData"
    />
    <Home v-else />
  </div>
</template>

<script>
import Home from "./Home.vue";
import DashboardView from "./DashboardView.vue";

export default {
  name: "AgenticDashboard",
  components: {
    Home,
    DashboardView,
  },
  computed: {
    dashboardId() {
      return this.$route.params.dashboardId || null;
    },
    dashboardName() {
      return this.$route.params.dashboardName || null;
    },
    hasMessage() {
      return !!this.$route.query.message;
    },
    initialMessage() {
      return this.$route.query.message || null;
    },
    dashboardData() {
      const dashboardDataStr = this.$route.query.dashboardData;
      if (dashboardDataStr) {
        try {
          return JSON.parse(dashboardDataStr);
        } catch (error) {
          console.error("Error parsing dashboard data:", error);
          return null;
        }
      }
      return null;
    },
    isHomeRoute() {
      return this.$route.name === "AgenticDashboard" && !this.$route.params.dashboardName && !this.$route.params.dashboardId;
    },
    isAllRoute() {
      return this.$route.name === "AgenticDashboardAll";
    },
    isStarredRoute() {
      return this.$route.name === "AgenticDashboardStarred";
    },
    isSharedRoute() {
      return this.$route.name === "AgenticDashboardShared";
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard.css';
</style>

